// Import Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Import Utils
import { getClassNames } from '../../../utils';

const Section = ({
  zeroBottomPadding,
  fullWidth,
  isFixed,
  isFixedSecondary,
  hasBgWhite,
  header,
  hasBgGrey,
  hasBgBlack,
  hasBorderBottom,
  paddingLeftXlarge,
  paddingLeftSuperLarge,
  offsetSmall,
  offsetLarge,
  children,
  cyopContainer,
  cyopFilterBar,
  ...props
}) => (
  <div className={getClassNames(props, 'c-section', {
    'c-section--fixed': isFixed,
    'c-section--fixed-secondary': isFixedSecondary,
    'u-background-white': hasBgWhite,
    'u-background-grey-600': hasBgGrey,
    'u-background-black': hasBgBlack,
    'c-section--border': hasBorderBottom,
    'c-section--header  js-calendar-header': header,
  })}
  >
    <section className={getClassNames(props, 'o-section', {
      'o-section--padding-bottom-zero': zeroBottomPadding,
    })}
    >
      <div className={getClassNames(props, 'o-container', {
        'o-container--full-width': fullWidth,
        'o-container--padding-left-xlarge@large': paddingLeftXlarge,
        'o-container--padding-left-superlarge@large': paddingLeftSuperLarge,
        'o-container--no-padding-left': cyopContainer,
        'o-container--cyop-filter-bar': cyopFilterBar,
      })}
      >
        <div className="o-grid">
          <div className={getClassNames(props, 'o-col o-col--10@small  o-col--11@large  o-col--padding-bottom-zero', {
            'o-col--offset-1@small': offsetSmall,
            'o-col--offset-1@large': offsetLarge,
          })}
          >
            <div className="o-col__inner">
              { children }
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);

Section.propTypes = {
  zeroBottomPadding: PropTypes.bool,
  fullWidth: PropTypes.bool,
  isFixed: PropTypes.bool,
  isFixedSecondary: PropTypes.bool,
  header: PropTypes.bool,
  paddingLeftXlarge: PropTypes.bool,
  paddingLeftSuperLarge: PropTypes.bool,
  hasBgWhite: PropTypes.bool,
  hasBgGrey: PropTypes.bool,
  hasBgBlack: PropTypes.bool,
  hasBorderBottom: PropTypes.bool,
  offsetSmall: PropTypes.bool,
  offsetLarge: PropTypes.bool,
  children: PropTypes.node.isRequired,
  cyopContainer: PropTypes.bool,
  cyopFilterBar: PropTypes.bool,
};

Section.defaultProps = {
  zeroBottomPadding: false,
  fullWidth: false,
  isFixed: false,
  isFixedSecondary: false,
  header: false,
  paddingLeftXlarge: false,
  paddingLeftSuperLarge: false,
  hasBgWhite: false,
  hasBgGrey: false,
  hasBgBlack: false,
  offsetSmall: false,
  offsetLarge: false,
  hasBorderBottom: false,
  cyopContainer: false,
  cyopFilterBar: false,
};

export default Section;
